import { bunja } from 'bunja';
import { atomWithMutation, queryClientAtom } from 'jotai-tanstack-query';

import { postDailyCheckInApi } from '@flipster/apis/v1/tradingCompetition';
import { Dialog, dialog } from '@flipster/react/design-system/dialog';
import { snackbar } from '@flipster/react/design-system/snackbar/index';
import { RouterScope } from '@flipster/react/providers/route';
import { checkAxiosError } from '@flipster/utils/axios';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';
import { getErrorCode, getErrorMessage } from '@flipster/utils/error';
import webviewHandler from '@flipster/utils/webview-handler';

import { CompetitionIdScope, dailyCheckInApiBunja } from '../../state';

export const dailyCheckInActionBunja = bunja(() => {
  const id = bunja.use(CompetitionIdScope);
  const store = bunja.use(JotaiStoreScope);
  const router = bunja.use(RouterScope);
  const { dailyCheckInQueryKeyAtom } = bunja.use(dailyCheckInApiBunja);

  const dailyCheckInMutationAtom = atomWithMutation(() => ({
    mutationFn: () => postDailyCheckInApi(id),
    onSuccess: () => {
      const queryClient = store.get(queryClientAtom);
      snackbar.success({ message: 'You’ve checked-in successfully.' });
      queryClient.refetchQueries({ queryKey: store.get(dailyCheckInQueryKeyAtom) });
    },
    onError: (err) => {
      if (!checkAxiosError(err)) return;
      const errorCode = getErrorCode(err);
      const message = getErrorMessage(err);

      switch (errorCode) {
        case 'api.unauthorized':
          dialog.open({
            title: { label: 'Notice' },
            content: message,
            buttons: {
              primary: (
                <Dialog.Button
                  hierarchy='primary'
                  label='Confirm'
                  onClick={() => {
                    webviewHandler.postMessage({ action: 'link', params: { page: 'signup' } }, () =>
                      router.push('/signup'),
                    );
                  }}
                />
              ),
            },
          });
          break;
        default:
          snackbar.error({ message: message });
          break;
      }
    },
  }));

  return {
    dailyCheckInMutationAtom,
  };
});
dailyCheckInActionBunja.debugLabel = 'dailyCheckInActionBunja';
